import { render, staticRenderFns } from "./ExitPay.vue?vue&type=template&id=20cbd60c&scoped=true&"
import script from "./ExitPay.vue?vue&type=script&lang=js&"
export * from "./ExitPay.vue?vue&type=script&lang=js&"
import style0 from "./ExitPay.vue?vue&type=style&index=0&id=20cbd60c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cbd60c",
  null
  
)

export default component.exports